import React from "react"
import { graphql, Link } from "gatsby"
import CommonTemplate from "templates/common-template"
import { Grid, Box } from "theme-ui"
import styled from "@emotion/styled"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const BorderBottom = styled.div`
    border-bottom: 2px dotted ${(props) => props.theme.colors.light_blue_1};
`
const RecentPost = styled(Box)`
    border-left: 2px solid ${(props) => props.theme.colors.light_blue_1};
    padding-left: 1rem;

    & a {
        text-decoration: none !important;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        border-left: none;
        padding-left: 0;
    }
`
// markup
const IndexPage = ({ location, data, pageContext }) => {
    const { pageData, posts } = data
    const modifiedData = { pageData: { ...pageData, ...data.category } }
    const customJsx = (
        <Grid gap={3} columns={[2, "3fr 1fr"]} className="grid-content">
            <Box>
                <h3>{pageData.published_date}</h3>
                <BorderBottom />
                <br />
                <GatsbyImage
                    image={getImage(pageData.image)}
                    alt={pageData.title}
                />
                <div
                    dangerouslySetInnerHTML={{ __html: pageData.Description }}
                ></div>
            </Box>
            <RecentPost>
                <h3>Recent Post</h3>
                <BorderBottom />
                {posts.edges.map((post, index) => (
                    <p key={index}>
                        <Link to={`/resources/${post.node.slug}`}>
                            {post.node.title}
                        </Link>
                    </p>
                ))}
            </RecentPost>
        </Grid>
    )

    const arrData = {
        location,
        data: modifiedData,
        bgColor:
            "linear-gradient(90deg, #ffb4b4 25%, #ffbdbd 25%, #ffbdbd 50%, #ffb4b4 50%, #ffb4b4 75%, #ffbdbd 75%, #ffbdbd 100%)",
        // galleryMinWidth: "40%", //default 0
        customElement: customJsx,
        parentLink: "resources",
        // breadcrums // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query ResourcesPostQuery($slug: String!) {
        pageData: strapiArticle(
            category: { slug: { eq: "resources" } }
            Post_Type: { eq: "Blog_Post" }
            slug: { eq: $slug }
        ) {
            title
            Description
            published_date
            image {
                childImageSharp {
                    gatsbyImageData(
                        placeholder: DOMINANT_COLOR
                        width: 900
                        height: 300
                    )
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
        }
        category: strapiPage(
            slug: { eq: "eip-resources" }
            company: { shortname: { eq: "EIP" } }
        ) {
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
        }
        posts: allStrapiArticle(
            sort: { fields: published_date, order: DESC }
            filter: {
                category: { slug: { eq: "resources" } }
                Post_Type: { eq: "Blog_Post" }
            }
        ) {
            edges {
                node {
                    slug
                    title
                }
            }
        }
    }
`
